export default "__VITE_ASSET__wWU77mtS__"